import { Loading } from "@omnijus/common";
import React, { useEffect, useState } from "react";
import { FiltrosAudienciaService } from "../../../services/filtros/filtros-audiencia-service";
import { FiltroStatusSolicitacaoAudiencia } from "../../../services/filtros/models/filtro-status-solicitacao-audiencia";
import { OmnijusSelectField } from "../../../shared/form/fields/omnijus-select-field";

interface OmnijusFiltroStatusSolicitacaoAudienciaProps {
    hideLabel?: boolean;
    name?: string;
    label?: string;
    isMulti?: boolean;
}

export const OmnijusFiltroStatusSolicitacaoAudiencia = (props: OmnijusFiltroStatusSolicitacaoAudienciaProps) => {
    const [promise, setPromise] = useState<Promise<Array<FiltroStatusSolicitacaoAudiencia> | undefined>>();
    const name = props.name || "idStatusSolicitacaoProcessoAudiencia"

    useEffect(() => {
        setPromise(FiltrosAudienciaService.listarStatusSolicitacaoAudiencia());
    }, []);

    return (
        <Loading promise={promise}>
            {(opcoes) => (
                <OmnijusSelectField
                    name={name}
                    label={props.hideLabel ? undefined : props.label || "Status Solicitação Audiência"}
                    isMulti={props.isMulti}
                    options={opcoes
                        ?.map((o) => ({
                            value: o.id.toString(),
                            label: o.value,
                        }))
                        .sort((a, b) => (a.label < b.label ? -1 : a.label > b.label ? 1 : 0))}
                />
            )}
        </Loading>
    );
};
